var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUploadBefore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 55,
  height: 56,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  filter: "url(#UploadBefore_svg__a)"
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 27.5,
  cy: 25.5,
  r: 25.5,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "UploadBefore_svg__b",
  width: 33,
  height: 33,
  x: 11,
  y: 9,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M11.317 9.317h32.564v32.564H11.317z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#UploadBefore_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3B82F6",
  d: "M19.458 36.454a2.61 2.61 0 0 1-1.917-.797 2.61 2.61 0 0 1-.797-1.917v-2.714q0-.576.39-.966t.967-.39.967.39.39.966v2.714H35.74v-2.714q0-.576.39-.966t.966-.39.967.39.39.966v2.714q0 1.119-.797 1.917a2.61 2.61 0 0 1-1.916.797zm6.784-16.486-2.544 2.544a1.26 1.26 0 0 1-.967.39 1.38 1.38 0 0 1-.967-.424 1.43 1.43 0 0 1-.39-.95 1.24 1.24 0 0 1 .39-.949l4.885-4.885a1.2 1.2 0 0 1 .44-.288q.24-.085.51-.085t.509.085q.237.086.44.288l4.885 4.885q.407.407.39.95a1.43 1.43 0 0 1-.39.95 1.38 1.38 0 0 1-.967.424 1.26 1.26 0 0 1-.966-.39l-2.544-2.545v9.702q0 .576-.39.966t-.967.39-.967-.39-.39-.966z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "UploadBefore_svg__a",
  width: 55,
  height: 56,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.364706 0 0 0 0 0.376471 0 0 0 0 0.431373 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_777_221"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_777_221",
  result: "shape"
})))));
export default SvgUploadBefore;